import SearchOrderPage from '@modules/landing/pages/SearchOrderPage';

export default SearchOrderPage;
